import { render, staticRenderFns } from "./ListHistoricalDevice.vue?vue&type=template&id=59ab9b7a&"
import script from "./ListHistoricalDevice.vue?vue&type=script&lang=js&"
export * from "./ListHistoricalDevice.vue?vue&type=script&lang=js&"
import style0 from "./ListHistoricalDevice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports